/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import ApiUtils from 'api/ApiUtils';
import React, {useEffect, useState} from 'react';
import {
  type ClubFormProps,
  type CategoryStatusList,
  type CategoryDetailsTypes,
} from 'utils/TypeConfig';
import categoryImagePlaceholder from 'assets/images/default-placeholder.jpg';

import {variables} from 'utils/constant';
import {Button, Col, Form, Row, Table} from 'react-bootstrap';

import {type FormikErrors, useFormik} from 'formik';
import * as Yup from 'yup';
import {toast} from 'react-toastify';

interface Club {
  id: number;
  name: string;
}
interface ClubRow {
  id: number;
  venue_id: string;
  name: string;
  is_active: string;
  commision_status: string;
  tag: string;
  indoors: string;
  outdoors: string;
  bar: string;
  guest_status: string;
  venue_open_time: string;
  guestlist_open_time: string;
  venue_close_time: string;
  guestlist_close_time: string;
  image: any;
  status: string;
}
interface ClubFormValues {
  clubs: ClubRow[]; // ✅ Ensure "clubs" exists in the type
}

const ClubForm: React.FC<ClubFormProps> = ({
  handleClose,
  setIsEditCategory,
  setIsAddCategory,
  editData,
  clubs,
}) => {
  const [status] = useState([
    {
      id: variables.RESTAURANT_ACTIVE_STATUS_ID,
      name: variables.RESTAURANT_ACTIVE_STATUS,
    },
    {
      id: variables.RESTAURANT_INACTIVE_STATUS_ID,
      name: variables.RESTAURANT_INACTIVE_STATUS,
    },
  ]);

  const guestStatus = [
    {
      id: variables.ACTIVE_STATUS_ID,
      name: variables.ACTIVE_STATUS,
    },
    {
      id: variables.INACTIVE_STATUS_ID,
      name: variables.INACTIVE_STATUS,
    },
  ];

  const clubType = [
    {
      id: 1,
      name: 'BeachClub',
    },
    {
      id: 2,
      name: 'NightClub',
    },
    {
      id: 3,
      name: 'After-parties',
    },
    {
      id: 4,
      name: 'Restaurant/Special Event',
    },
  ];

  const [statusType] = useState([
    {id: variables.EVENT_ACTIVE_STATUS_ID, name: variables.EVENT_ACTIVE_STATUS},
    {
      id: variables.EVENT_INACTIVE_STATUS_ID,
      name: variables.EVENT_INACTIVE_STATUS,
    },
  ]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [VenueTypeOption, setVenueTypeOption] = useState<any>([]);
  useEffect(() => {
    // fetch venue_id type
    const fetchVenueTypeList = async (): Promise<void> => {
      try {
        const response: any = await ApiUtils.TypeVenue(); // Ensure parentheses
        const mapData = response?.data?.map((option: any) => {
          return {
            id: option.id,
            name: option.name,
          };
        });

        setVenueTypeOption(mapData || []); // Update state with fetched data
      } catch (error) {
        console.error('Error fetching dress code list:', error);
      }
    };
    void fetchVenueTypeList();
  }, []);
  const [imageDisplay, setImageDisplay] = useState<any>(editData?.logo || '');
  const [isImageChange, setisImageChange] = useState(false);
  const handleImage = async (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
    venuewImage: boolean = false,
  ): Promise<void> => {
    if (venuewImage) {
      editData?.id
        ? await formikEdit.setFieldValue('image', e)
        : await formik.setFieldValue(`clubs.${index}.image`, e);
      setisImageChange(true);
    } else {
      const file = e.target.files?.[0];

      if (file !== null && file) {
        const validImageTypes = [
          'image/jpeg',
          'image/png',
          'image/jpg',
          'image/webp',
        ];

        if (!validImageTypes.includes(file?.type)) {
          // console.error(
          //   'Invalid file type. Please upload an image of type: jpeg, png, jpg, gif, svg, webp. 111111',
          // );
          alert(
            'Invalid file type. Please upload an image of type: jpeg, png, jpg,webp',
          );
          return; // Exit the function if the file type is not valid
        }
        console.log('🚀 ~ handleImage ~ file:', file);
        const objectUrl: string = URL.createObjectURL(file);
        editData?.id
          ? setImageDisplay(objectUrl)
          : setImageDisplay((prevState: any) => ({
              ...prevState,
              [index]: objectUrl,
            }));

        editData?.id
          ? await formikEdit.setFieldValue('image', file)
          : await formik.setFieldValue(`clubs.${index}.image`, file);
      }
    }
  };

  const initialRow: ClubRow = {
    id: 1, // Default ID
    name: '',
    venue_id: '',
    is_active: '',
    commision_status: '',
    tag: '',
    indoors: '',
    outdoors: '',
    bar: '',
    guest_status: '',
    venue_open_time: '',
    venue_close_time: '',
    guestlist_open_time: '',
    guestlist_close_time: '',
    image: '',
    status: '',
  };

  const [rows, setRows] = useState([{...initialRow}]);

  const [submittedRows, setSubmittedRows] = useState<any[]>([]);

  const [venueList, setVenueList] = useState([]);
  useEffect(() => {
    const fetchCategoryList = async (): Promise<void> => {
      try {
        const response: any = await ApiUtils.getVenueList('?type=club');
        setVenueList(response);
      } catch (err) {
        console.error(err);
      }
    };

    void fetchCategoryList();
  }, []);

  // Function to conditionally apply validation to multiple fields
  const conditionalRequired = (fields: string[]): any => {
    return fields.reduce<Record<string, Yup.StringSchema>>((acc, field) => {
      acc[field] = Yup.string().when('is_active', {
        is: (val: any) => val !== '3',
        then: schema =>
          schema.required(`${field.replace('_', ' ')} is required`),
        otherwise: schema => schema.notRequired(),
      });
      return acc;
    }, {});
  };

  // // Define fields that require conditional validation
  // const conditionalFields = [
  //   'commision_status',
  //   'tag',
  //   'indoors',
  //   'outdoors',
  //   'bar',
  //   'venue_open_time',
  //   'venue_close_time',
  //   'guestlist_open_time',
  //   'guestlist_close_time',
  //   'image',
  //   'status',
  // ];

  // const validationSchema = Yup.object({
  //   clubs: Yup.array().of(
  //     Yup.object().shape({
  //       id: Yup.number().required(),
  //       // name: Yup.string().required('Name is required'),
  //       name: Yup.string()
  //         .required('Name is required')
  //         .test('unique-name', 'Club name already available', function (value) {
  //           // 🔥 Keep the "already available" error if it's set
  //           return !this.parent.nameTaken;
  //         }),
  //       is_active: Yup.string().required('Type is required'),
  //       ...conditionalRequired(conditionalFields), // Apply optimized validation
  //     }),
  //   ),
  // });

  const validationSchema = Yup.object({
    clubs: Yup.array().of(
      Yup.object().shape({
        id: Yup.number().required('ID is required'),
        name: Yup.string()
          .required('Name is required')
          .test('unique-name', 'Club name already available', function (value) {
            return !this.parent.nameTaken;
          }),
        venue_id: Yup.string().required('Venue is required'),
        is_active: Yup.string().required('Type is required'),
        commision_status: Yup.string().test(
          'is_active-test',
          'Commision Status is required',
          function (value) {
            return this.parent.is_active === '3' || !!value;
          },
        ),
        tag: Yup.string().test(
          'is_active-test',
          'Tag is required',
          function (value) {
            return this.parent.is_active === '3' || !!value;
          },
        ),
        indoors: Yup.string().test(
          'is_active-test',
          'Indoors is required',
          function (value) {
            return this.parent.is_active === '3' || !!value;
          },
        ),
        outdoors: Yup.string().test(
          'is_active-test',
          'Outdoors is required',
          function (value) {
            return this.parent.is_active === '3' || !!value;
          },
        ),
        bar: Yup.string().test(
          'is_active-test',
          'Bar is required',
          function (value) {
            return this.parent.is_active === '3' || !!value;
          },
        ),
        guest_status: Yup.string().test(
          'is_active-test',
          'Guest list status is required',
          function (value) {
            return this.parent.is_active === '3' || !!value;
          },
        ),
        venue_open_time: Yup.string().test(
          'is_active-test',
          'Venue Open Time is required',
          function (value) {
            return this.parent.is_active === '3' || !!value;
          },
        ),
        venue_close_time: Yup.string()
          .test(
            'is_active-test',
            'Venue Close Time is required',
            function (value) {
              return this.parent.is_active === '3' || !!value;
            },
          )
          .test(
            'time-order',
            'Venue Close Time must be after Venue Open Time',
            function (value) {
              const {venue_open_time} = this.parent;
              return !venue_open_time || !value || value >= venue_open_time;
            },
          ),

        guestlist_open_time: Yup.string().when(['is_active', 'guest_status'], {
          is: (isActive: any, guestStatus: any) =>
            isActive === '3' || guestStatus === '1',
          then: schema => schema.required('Guestlist Open Time is required'),
        }),
        guestlist_close_time: Yup.string()
          .when(['is_active', 'guest_status'], {
            is: (isActive: any, guestStatus: any) =>
              isActive === '3' || guestStatus === '1',
            then: schema => schema.required('Guestlist Close Time is required'),
          })
          .test(
            'time-order',
            'Guestlist Close Time must be after Guestlist Open Time',
            function (value) {
              const {guestlist_open_time} = this.parent;
              return (
                !guestlist_open_time || !value || value >= guestlist_open_time
              );
            },
          ),
        image: Yup.string().required('Image is required'),
        status: Yup.string().required('Status is required'),
      }),
    ),
  });

  // const validationSchema = Yup.object({
  //   clubs: Yup.array().of(
  //     Yup.object().shape({
  //       id: Yup.number().required(),
  //       name: Yup.string().required('Name is required'),
  //       is_active: Yup.string().required('Type is required'),
  //       commision_status: Yup.string().required('Commision status is required'),
  //       tag: Yup.string().required('tag is required'),
  //       indoors: Yup.string().required('Indoors status is required'),
  //       outdoors: Yup.string().required('Outdoors status is required'),
  //       bar: Yup.string().required('Bar status is required'),
  //       special_events: Yup.string().required('Special event is required'),
  //       opening_time: Yup.string().required('Opening time is required'),
  //       service_time: Yup.string().required('Service / time is required'),
  //       max_party_size: Yup.string().required('Max party size is required'),
  //       price_range: Yup.string().required('Price range is required'),
  //       description: Yup.string().required('Description is required'),
  //       image: Yup.mixed().required('Logo is required'),
  //     }),
  //   ),
  // });
  const formik = useFormik<ClubFormValues>({
    initialValues: {
      clubs: rows.map(row => ({
        id: row.id,
        name: '',
        venue_id: '',
        is_active: '',
        commision_status: '',
        tag: '',
        indoors: '',
        outdoors: '',
        bar: '',
        guest_status: '',
        venue_open_time: '',
        venue_close_time: '',
        guestlist_open_time: '',
        guestlist_close_time: '',
        image: '',
        status: '',
      })),
    },
    validationSchema,
    onSubmit: async values => {
      console.log('Submitting all rows:', values.clubs);

      try {
        const responses = await Promise.all(
          values.clubs.map(async club => {
            const formData = new FormData();
            formData.append('club_id', club.id.toString());
            formData.append('venue_id', club.venue_id.toString());
            formData.append('name', club?.name || '');
            formData.append('type', club?.is_active || '');
            if (club?.is_active !== '3') {
              formData.append('indoors', club?.indoors || '');
              formData.append('outdoors', club.outdoors || '');
              formData.append('bar', club.bar || '');
              formData.append('guest_status', club.guest_status || '');

              formData.append('venue_open_time', club.venue_open_time || '');
              formData.append('venue_close_time', club.venue_close_time || '');
              formData.append(
                'guestlist_open_time',
                club.guestlist_open_time || '',
              );
              formData.append(
                'guestlist_close_time',
                club.guestlist_close_time || '',
              );

              formData.append('tag', club.tag || '');
              formData.append('commission', club.commision_status || '');
              formData.append('status', club.status || '');
            }

            // Append logo only if it's a File object
            if (club.image instanceof File) {
              formData.append('logo', club.image);
            } else {
              console.log('Logo is not a file, skipping upload');
              formData.append('logo', club?.image);
            }

            return await ApiUtils.addClubProfile(formData);
          }),
        );

        responses.forEach((response: any) => toast.success(response.message));

        if (setIsAddCategory) {
          setIsAddCategory((prev: boolean) => !prev);
        }
        handleClose();
      } catch (error: any) {
        toast.error(error?.response?.data?.message || 'Submission failed');
      }
    },
  });

  console.log('formikformik', formik.errors);

  const addRow = async (): Promise<void> => {
    const newRow: ClubRow = {...initialRow, id: rows.length + 1};
    setRows([...rows, newRow]);

    await formik.setValues({
      clubs: [...formik.values.clubs, newRow],
    });
  };

  const removeRow = async (index: number): Promise<void> => {
    if (rows.length > 1) {
      // Remove row from the `rows` state
      const updatedRows = rows.filter((_, i) => i !== index);
      setRows(updatedRows);

      // Remove the corresponding row from Formik values
      const updatedClubs = formik.values.clubs.filter((_, i) => i !== index);

      // Ensure Formik updates properly
      await formik.setValues({...formik.values, clubs: updatedClubs});

      // Remove errors and touched state correctly
      const updatedErrors: Array<FormikErrors<ClubRow>> = Array.isArray(
        formik.errors.clubs,
      )
        ? formik.errors.clubs.filter(
            (error): error is FormikErrors<ClubRow> =>
              typeof error !== 'string',
          )
        : [];

      const updatedTouched =
        Array.isArray(formik.touched.clubs) && formik.touched.clubs.length
          ? formik.touched.clubs.filter((_, i) => i !== index)
          : [];

      // Update errors and touched
      formik.setErrors({...formik.errors, clubs: updatedErrors});
      await formik.setTouched({...formik.touched, clubs: updatedTouched});

      // **🔹 Remove the image for the deleted row**

      setImageDisplay((prevState: any) => {
        const updatedImages: Record<number, string> = {};

        Object.keys(prevState).forEach((key, i) => {
          const oldIndex = Number(key);
          if (oldIndex !== index) {
            const newIndex = oldIndex > index ? oldIndex - 1 : oldIndex;
            updatedImages[newIndex] = prevState[oldIndex]; // Shift images
          }
        });

        return updatedImages;
      });
      // Ensure UI updates correctly
      await formik.validateForm();
    }
  };

  const validationSchemaEdit = Yup.object().shape({
    id: Yup.string().required(),
    name: Yup.string()
      .required('Name is required')
      .test(
        'unique-name',
        'Restaurant name already available',
        function (value) {
          // 🔥 Keep the "already available" error if it's set
          return !this.parent.nameTaken;
        },
      ),
    venue_id: Yup.string().required('Venue is required'),
    is_active: Yup.string().required('Type is required'),
    commision_status: Yup.string().test(
      'is_active-test',
      'Commision Status is required',
      function (value) {
        return this.parent.is_active === '3' || !!value;
      },
    ),
    tag: Yup.string().test(
      'is_active-test',
      'Tag is required',
      function (value) {
        return this.parent.is_active === '3' || !!value;
      },
    ),
    indoors: Yup.string().test(
      'is_active-test',
      'Indoors is required',
      function (value) {
        return this.parent.is_active === '3' || !!value;
      },
    ),
    outdoors: Yup.string().test(
      'is_active-test',
      'Outdoors is required',
      function (value) {
        return this.parent.is_active === '3' || !!value;
      },
    ),
    bar: Yup.string().test(
      'is_active-test',
      'Bar is required',
      function (value) {
        return this.parent.is_active === '3' || !!value;
      },
    ),
    venue_close_time: Yup.string()
      .test('is_active-test', 'Venue Close Time is required', function (value) {
        return this.parent.is_active === '3' || !!value;
      })
      .test(
        'time-order',
        'Venue Close Time must be after Venue Open Time',
        function (value) {
          const {venue_open_time} = this.parent;
          return !venue_open_time || !value || value >= venue_open_time;
        },
      ),
    guestlist_open_time: Yup.string().when(['is_active', 'guest_status'], {
      is: (isActive: any, guestStatus: any) =>
        isActive === '3' || guestStatus === '1',
      then: schema => schema.required('Guestlist Open Time is required'),
    }),
    guestlist_close_time: Yup.string()
      .when(['is_active', 'guest_status'], {
        is: (isActive: any, guestStatus: any) =>
          isActive === '3' || guestStatus === '1',
        then: schema => schema.required('Guestlist Close Time is required'),
      })
      .test(
        'time-order',
        'Guestlist Close Time must be after Guestlist Open Time',
        function (value) {
          const {guestlist_open_time} = this.parent;
          return !guestlist_open_time || !value || value >= guestlist_open_time;
        },
      ),
    image: Yup.string().required('Image is required'),
    status: Yup.string().required('Status is required'),
  });
  // const formikEdit = editData?.id ? formikArray?.[editData?.id] ?? null : null ;
  // 🔹 Create a separate formik instance for editData
  const formikEdit = useFormik({
    initialValues: {
      id: editData?.id ?? '',
      name: editData?.club_name ?? '',
      venue_id: editData?.venue_id ?? '',
      is_active: editData?.type ?? '',
      commision_status: editData?.commission ?? '',
      tag: editData?.tag ?? '',
      indoors: editData?.indoors ?? '',
      outdoors: editData?.outdoors ?? '',
      bar: editData?.bar ?? '',
      guest_status: editData?.guest_status ?? '',
      venue_open_time: editData?.venue_open_time ?? '',
      venue_close_time: editData?.venue_close_time ?? '',
      guestlist_open_time: editData?.guestlist_open_time ?? '',
      guestlist_close_time: editData?.guestlist_close_time ?? '',
      image: editData?.logo ?? null,
      status: editData?.status ?? '',
    },
    enableReinitialize: true, // Ensures form updates when editData changes
    validationSchema: validationSchemaEdit,
    onSubmit: async values => {
      // console.log('Submitting editData:', {id: editData?.id, ...values});

      try {
        const formData = {
          id: editData?.id,
          name: values?.name,
          venue_id: values?.venue_id,
          club_id: editData?.club_id,
          type: values?.is_active,
          indoors: values?.indoors,
          outdoors: values?.outdoors,
          bar: values?.bar,
          guest_status: values?.guest_status,
          venue_open_time: values?.venue_open_time,
          venue_close_time: values?.venue_close_time,
          guestlist_open_time: values?.guestlist_open_time,
          guestlist_close_time: values?.guestlist_close_time,
          tag: values?.tag,
          commission: values?.commision_status,
          // logo: typeof values?.image !== 'string' ? values?.image : {},
          logo:
            typeof values?.image !== 'string'
              ? values?.image
              : isImageChange
                ? values?.image
                : {},
          status: values?.status,
        };

        const response: any = await ApiUtils.addClubProfile(formData);
        toast.success(response?.message);

        if (setIsEditCategory) {
          setIsEditCategory((prev: boolean) => !prev);
        }
        handleClose();
      } catch (error: any) {
        toast.error(error?.response?.data?.message);
      }
    },
  });
  // Ensure form validation triggers
  const handleEditSubmit = async (): Promise<void> => {
    await formikEdit.setTouched({
      is_active: true,
      venue_id: true,
      name: true,
      commision_status: true,
      tag: true,
      indoors: true,
      outdoors: true,
      bar: true,
      venue_open_time: true,
      venue_close_time: true,
      guestlist_open_time: true,
      guestlist_close_time: true,
      image: true,
      status: true,
    });

    await formikEdit.validateForm().then(errors => {
      if (Object.keys(errors).length === 0) {
        console.log('formikEdit?.errors', errors);
        formikEdit.handleSubmit();
      } else {
        console.log('formikEdit?.errors edit', errors);
      }
    });
  };

  // console.log('formikEdit?.values', formikEdit?.values);

  const checkRestaurantNameAvailability = async (
    name: string,
    index: number,
  ): Promise<boolean> => {
    try {
      const formData = {
        name,
        ...(editData?.id && {old_name: editData?.club_name}),
      };
      const response: any = await ApiUtils.checkClubNameAvailability(formData);

      if (response?.data?.is_exists === true) {
        if (editData?.id) {
          await formikEdit.setFieldTouched(`name`, true);

          // ✅ Set a hidden flag to persist error
          await formikEdit.setFieldValue(`nameTaken`, true, false); // Prevents immediate revalidation

          // ✅ Set field error
          formikEdit.setFieldError(`name`, 'Restaurant name already available');
        } else {
          await formik.setFieldTouched(`clubs[${index}].name`, true);

          // ✅ Set a hidden flag to persist error
          await formik.setFieldValue(`clubs[${index}].nameTaken`, true, false); // Prevents immediate revalidation

          // ✅ Set field error
          formik.setFieldError(
            `clubs[${index}].name`,
            'Club name already available',
          );
        }
        return false;
      } else {
        // ✅ Remove error if name is available
        await formik.setFieldValue(`clubs[${index}].nameTaken`, false, false);
        formik.setFieldError(`clubs[${index}].name`, undefined);

        await formikEdit.setFieldValue(`nameTaken`, false, false);
        formikEdit.setFieldError(`name`, undefined);
        return true;
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
      return false;
    }
  };
  return (
    <div>
      {/* <Container fluid className="p-3"> */}
      <Row>
        <Col>
          <div className="table-responsive">
            <Table striped bordered hover className="text-center club-table">
              <thead className="bg-light">
                <tr>
                  <th>Venue</th>
                  <th>Logo</th>
                  <th>Club Name</th>
                  <th>Type</th>
                  <th>Do they pay Commission? </th>
                  <th>Tag</th>
                  <th>Indoors</th>
                  <th>Outdoors</th>
                  <th>Bar</th>
                  <th>Guest List status</th>
                  <th>Venue Opening time</th>
                  <th>venue Closing time</th>
                  <th>Guestlist Opening time</th>
                  <th>Guestlist Closing time</th>
                  <th>Status</th>
                  {!editData?.id ? <th></th> : null}
                </tr>
              </thead>
              <tbody>
                {/* {clubs.map((club, index) => ( */}
                {editData?.id ? (
                  <>
                    <tr key={editData?.id}>
                      <td>
                        <div className="venue-id-select">
                          <Form.Select
                            style={{minWidth: '120px'}}
                            className="form-select"
                            name="venue_id"
                            id={`venue_id${editData?.id}`}
                            value={formikEdit?.values?.venue_id}
                            // onChange={formikEdit?.handleChange}
                            onChange={async e => {
                              // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
                              const selectedVenue: any = venueList.find(
                                // eslint-disable-next-line array-callback-return
                                (venue: CategoryDetailsTypes) =>
                                  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                                  String(venue.id) == e.target.value,
                              );

                              await handleImage(
                                selectedVenue?.image,
                                editData?.id,
                                true,
                              );

                              setImageDisplay(selectedVenue?.image);
                              setTimeout(() => {
                                void formikEdit.setFieldValue(
                                  `venue_id`,
                                  selectedVenue?.id || '',
                                );
                              }, 0);

                              // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                              formikEdit?.handleChange(e);
                            }}
                            onBlur={formikEdit?.handleBlur}>
                            <option disabled value="">
                              --Select Venue--
                            </option>
                            {venueList?.map(
                              (
                                data: CategoryStatusList,
                                i: React.Key | null | undefined,
                              ) => (
                                <option key={i} value={data.id}>
                                  {data.name}
                                </option>
                              ),
                            )}
                          </Form.Select>
                          {formikEdit?.touched.venue_id &&
                            formikEdit?.errors.venue_id && (
                              <p className="text-danger">
                                {formikEdit?.errors.venue_id as string}
                              </p>
                            )}
                        </div>
                      </td>
                      <td>
                        <div className="club-select">
                          <div className="avatar-upload">
                            <div className="avatar-edit">
                              <input
                                type="file"
                                // id="imageUpload"
                                id={`imageUpload`}
                                name={`image`}
                                onChange={async e => {
                                  await handleImage(e, editData?.id);
                                }}
                                accept="image/jpeg, image/png, image/jpg, image/gif, image/svg+xml, image/webp"
                              />
                              <label
                                htmlFor={`imageUpload`}
                                className="image-upload-cam d-flex justify-content-center align-items-center">
                                <i className="ri-image-fill"></i>
                              </label>
                            </div>
                            <div className="avatar-preview">
                              <img
                                className="preview-select-img img-responsive img-circle"
                                id="imagePreview"
                                alt="User profile picture"
                                src={imageDisplay ?? categoryImagePlaceholder}
                                style={{height: '110px'}}
                              />
                            </div>
                          </div>
                          {formikEdit?.touched.image &&
                            formikEdit?.errors.image && (
                              <p className="text-danger">
                                {formikEdit?.errors.image as string}
                              </p>
                            )}
                        </div>
                      </td>
                      <td>
                        <div className="club-select">
                          <div className="club-select">
                            <Form.Control
                              type="text"
                              name="name"
                              id={`name${editData?.id}`}
                              value={formikEdit?.values.name}
                              onChange={formikEdit?.handleChange}
                              // onBlur={formikEdit?.handleBlur}
                              onBlur={async e => {
                                const isAvailable =
                                  await checkRestaurantNameAvailability(
                                    formikEdit?.values.name,
                                    editData?.id,
                                  );
                                formikEdit?.handleBlur(e);
                              }}
                              isInvalid={
                                !!(
                                  formikEdit?.touched.name &&
                                  formikEdit?.errors.name
                                )
                              }
                            />
                            {formikEdit?.touched.name &&
                              formikEdit?.errors.name && (
                                <p className="text-danger">
                                  {formikEdit?.errors.name as string}
                                </p>
                              )}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="mb-3 club-select">
                          <div className="d-flex"></div>
                          <Form.Select
                            className="form-select"
                            id={`status-Field${editData?.id}`}
                            name="is_active"
                            value={formikEdit?.values?.is_active ?? ''}
                            onChange={formikEdit?.handleChange}
                            onBlur={formikEdit?.handleBlur} // Ensure field is marked as touched
                          >
                            <option disabled value=" ">
                              --Select Type--
                            </option>
                            {clubType?.map((data: CategoryStatusList, i) => (
                              <option key={i} value={data.id}>
                                {data.name}
                              </option>
                            ))}
                          </Form.Select>
                          {formikEdit?.touched.is_active &&
                            formikEdit?.errors.is_active && (
                              <p className="text-danger">
                                {formikEdit?.errors.is_active as string}
                              </p>
                            )}
                        </div>
                      </td>
                      <td>
                        <div className="mb-3 club-select">
                          <Form.Select
                            className="form-select"
                            name="commision_status"
                            id={`commision_status${editData?.id}`}
                            value={formikEdit?.values.commision_status}
                            onChange={formikEdit?.handleChange}
                            onBlur={formikEdit?.handleBlur}
                            disabled={
                              String(formikEdit?.values.is_active) === '3'
                            } // Condition to disable
                          >
                            <option disabled value="">
                              --Select--
                            </option>
                            {status?.map((data: CategoryStatusList, i) => (
                              <option key={i} value={data.id}>
                                {data.name}
                              </option>
                            ))}
                          </Form.Select>
                          {formikEdit?.touched.commision_status &&
                            formikEdit?.errors.commision_status && (
                              <p className="text-danger">
                                {formikEdit?.errors.commision_status as string}
                              </p>
                            )}
                        </div>
                      </td>
                      <td>
                        <div className="mb-3 club-select">
                          <Form.Control
                            type="text"
                            name="tag"
                            id={`tag${editData?.id}`}
                            value={formikEdit?.values.tag}
                            onChange={formikEdit?.handleChange}
                            onBlur={formikEdit?.handleBlur}
                            disabled={
                              String(formikEdit?.values.is_active) === '3'
                            }
                            isInvalid={
                              !!(
                                formikEdit?.touched.tag &&
                                formikEdit?.errors.tag
                              )
                            }
                          />
                          {formikEdit?.touched.tag &&
                            formikEdit?.errors.tag && (
                              <p className="text-danger">
                                {formikEdit?.errors.tag as string}
                              </p>
                            )}
                        </div>
                      </td>
                      <td>
                        <div className="club-select">
                          <Form.Select
                            className="form-select "
                            name="indoors"
                            id={`indoors${editData?.id}`}
                            value={formikEdit?.values.indoors}
                            onChange={formikEdit?.handleChange}
                            onBlur={formikEdit?.handleBlur}
                            disabled={
                              String(formikEdit?.values.is_active) === '3'
                            }>
                            <option disabled value="">
                              --Select Indoors--
                            </option>
                            {status?.map((data: CategoryStatusList, i) => (
                              <option key={i} value={data.id}>
                                {data.name}
                              </option>
                            ))}
                          </Form.Select>
                          {formikEdit?.touched.indoors &&
                            formikEdit?.errors.indoors && (
                              <p className="text-danger">
                                {formikEdit?.errors.indoors as string}
                              </p>
                            )}
                        </div>
                      </td>
                      <td>
                        <div className="club-select">
                          <Form.Select
                            className="form-select "
                            name="outdoors"
                            id={`outdoors${editData?.id}`}
                            value={formikEdit?.values.outdoors}
                            onChange={formikEdit?.handleChange}
                            onBlur={formikEdit?.handleBlur}
                            disabled={
                              String(formikEdit?.values.is_active) === '3'
                            }>
                            <option disabled value="">
                              --Select Outdoors--
                            </option>
                            {status?.map((data: CategoryStatusList, i) => (
                              <option key={i} value={data.id}>
                                {data.name}
                              </option>
                            ))}
                          </Form.Select>
                          {formikEdit?.touched.outdoors &&
                            formikEdit?.errors.outdoors && (
                              <p className="text-danger">
                                {formikEdit?.errors.outdoors as string}
                              </p>
                            )}
                        </div>
                      </td>
                      <td>
                        <div className="club-select">
                          <Form.Select
                            className="form-select "
                            name="bar"
                            id={`bar${editData?.id}`}
                            value={formikEdit?.values.bar}
                            onChange={formikEdit?.handleChange}
                            onBlur={formikEdit?.handleBlur}
                            disabled={
                              String(formikEdit?.values.is_active) === '3'
                            }>
                            <option disabled value="">
                              --Select bar--
                            </option>
                            {status?.map((data: CategoryStatusList, i) => (
                              <option key={i} value={data.id}>
                                {data.name}
                              </option>
                            ))}
                          </Form.Select>
                          {formikEdit?.touched.bar &&
                            formikEdit?.errors.bar && (
                              <p className="text-danger">
                                {formikEdit?.errors.bar as string}
                              </p>
                            )}
                        </div>
                      </td>

                      <td>
                        <div className="club-select">
                          <Form.Select
                            className="form-select "
                            name="guest_status"
                            id={`guest_status${editData?.id}`}
                            value={formikEdit?.values.guest_status}
                            onChange={formikEdit?.handleChange}
                            onBlur={formikEdit?.handleBlur}
                            disabled={
                              String(formikEdit?.values.is_active) === '3'
                            }>
                            <option disabled value="">
                              --Select Guest List Status--
                            </option>
                            {guestStatus?.map((data: CategoryStatusList, i) => (
                              <option key={i} value={data.id}>
                                {data.name}
                              </option>
                            ))}
                          </Form.Select>
                          {formikEdit?.touched.guest_status &&
                            formikEdit?.errors.guest_status && (
                              <p className="text-danger">
                                {formikEdit?.errors.guest_status as string}
                              </p>
                            )}
                        </div>
                      </td>

                      <td>
                        <div className="club-select">
                          <Form.Control
                            type="time"
                            placeholder="Enter venue opening time"
                            name="venue_open_time"
                            id={`venue-open-time${editData?.id}`}
                            value={formikEdit?.values.venue_open_time}
                            onChange={formikEdit?.handleChange}
                            onBlur={formikEdit?.handleBlur}
                            disabled={
                              String(formikEdit?.values.is_active) === '3'
                            }
                            isInvalid={
                              !!(
                                formikEdit?.touched.venue_open_time &&
                                formikEdit?.errors.venue_open_time
                              )
                            }
                          />
                          {formikEdit?.touched.venue_open_time &&
                            formikEdit?.errors.venue_open_time && (
                              <p className="text-danger">
                                {formikEdit?.errors.venue_open_time as string}
                              </p>
                            )}
                        </div>
                      </td>

                      <td>
                        <div className="club-select">
                          <Form.Control
                            type="time"
                            placeholder="Enter venue closing time"
                            name="venue_close_time"
                            id={`venue-close-time${editData?.id}`}
                            value={formikEdit?.values.venue_close_time}
                            onChange={formikEdit?.handleChange}
                            onBlur={formikEdit?.handleBlur}
                            disabled={
                              String(formikEdit?.values.is_active) === '3'
                            }
                            isInvalid={
                              !!(
                                formikEdit?.touched.venue_close_time &&
                                formikEdit?.errors.venue_close_time
                              )
                            }
                          />
                          {formikEdit?.touched.venue_close_time &&
                            formikEdit?.errors.venue_close_time && (
                              <p className="text-danger">
                                {formikEdit?.errors.venue_close_time as string}
                              </p>
                            )}
                        </div>
                      </td>

                      {/* {formikEdit?.values.guest_status &&
                      formikEdit?.values.guest_status == '1' ? (
                        <> */}
                      <td>
                        <div className="club-select">
                          <Form.Control
                            type="time"
                            placeholder="Enter venue opening time"
                            name="guestlist_open_time"
                            id={`guestlist-open-time${editData?.id}`}
                            value={formikEdit?.values.guestlist_open_time}
                            onChange={formikEdit?.handleChange}
                            onBlur={formikEdit?.handleBlur}
                            disabled={
                              String(formikEdit?.values.is_active) === '3' ||
                              formikEdit?.values.guest_status != '1'
                            }
                            isInvalid={
                              !!(
                                formikEdit?.touched.guestlist_open_time &&
                                formikEdit?.errors.guestlist_open_time
                              )
                            }
                          />
                          {formikEdit?.touched.guestlist_open_time &&
                            formikEdit?.errors.guestlist_open_time && (
                              <p className="text-danger">
                                {
                                  formikEdit?.errors
                                    .guestlist_open_time as string
                                }
                              </p>
                            )}
                        </div>
                      </td>

                      <td>
                        <div className="club-select">
                          <Form.Control
                            type="time"
                            placeholder="Enter guestlist closing time"
                            name="guestlist_close_time"
                            id={`guestlist-close-time${editData?.id}`}
                            value={formikEdit?.values.guestlist_close_time}
                            onChange={formikEdit?.handleChange}
                            onBlur={formikEdit?.handleBlur}
                            disabled={
                              String(formikEdit?.values.is_active) === '3' ||
                              formikEdit?.values.guest_status != '1'
                            }
                            isInvalid={
                              !!(
                                formikEdit?.touched.guestlist_close_time &&
                                formikEdit?.errors.guestlist_close_time
                              )
                            }
                          />
                          {formikEdit?.touched.guestlist_close_time &&
                            formikEdit?.errors.guestlist_close_time && (
                              <p className="text-danger">
                                {
                                  formikEdit?.errors
                                    .guestlist_close_time as string
                                }
                              </p>
                            )}
                        </div>
                      </td>
                      {/* </>
                      ) : (
                        <>
                          <td></td>
                          <td></td>
                        </>
                      )} */}

                      <td>
                        <div className="mb-3 club-select">
                          <div className="d-flex"></div>
                          <Form.Select
                            className="form-select"
                            id={`status-Field${editData?.id}`}
                            name="status"
                            value={formikEdit?.values.status}
                            onChange={formikEdit.handleChange}
                            onBlur={formikEdit.handleBlur}>
                            <option disabled value=" ">
                              --Select--
                            </option>
                            {statusType?.map((data: CategoryStatusList, i) => (
                              <option key={i} value={data.id}>
                                {data.name}
                              </option>
                            ))}
                          </Form.Select>
                          {formikEdit?.touched.status &&
                            formikEdit?.errors.status && (
                              <p className="text-danger">
                                {formikEdit?.errors.status as string}
                              </p>
                            )}
                        </div>
                      </td>
                    </tr>
                  </>
                ) : (
                  <>
                    {formik.values.clubs.map((club, index) => (
                      // // Check if the row is submitted

                      <tr key={club?.id}>
                        <td>
                          <div className="mb-3 club-select">
                            <div className="d-flex"></div>
                            <Form.Select
                              className="form-select"
                              id={`venue-id-Field${index}`}
                              name={`clubs[${index}].venue_id`}
                              value={club.venue_id}
                              // onChange={formik.handleChange}
                              onChange={async e => {
                                // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
                                const selectedVenue: any = venueList.find(
                                  // eslint-disable-next-line array-callback-return
                                  (venue: CategoryDetailsTypes) =>
                                    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                                    String(venue.id) == e.target.value,
                                );

                                await handleImage(
                                  selectedVenue?.image,
                                  index,
                                  true,
                                );

                                setImageDisplay((prevState: any) => ({
                                  ...prevState,
                                  [index]: selectedVenue?.image,
                                }));
                                setTimeout(() => {
                                  void formik.setFieldValue(
                                    `clubs[${index}].venue_id`,
                                    selectedVenue?.id || '',
                                  );
                                }, 0);

                                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                                formik?.handleChange(e);
                              }}
                              onBlur={formik.handleBlur}>
                              <option value=" ">--Select Venue-- </option>
                              {venueList?.map((data: CategoryStatusList, i) => (
                                <option key={i} value={data.id}>
                                  {data.name}
                                </option>
                              ))}
                            </Form.Select>
                            {formik.touched.clubs?.[index]?.venue_id &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {
                                    (formik.errors.clubs[index] as any)
                                      ?.venue_id
                                  }
                                </p>
                              )}
                          </div>
                        </td>

                        <td>
                          <div className="club-select">
                            <div className="avatar-upload">
                              <div className="avatar-edit">
                                <input
                                  type="file"
                                  // id="imageUpload"
                                  id={`imageUpload${index}`}
                                  name={`clubs[${index}].image`}
                                  onChange={async e => {
                                    await handleImage(e, index);
                                  }}
                                  accept="image/jpeg, image/png, image/jpg, image/gif, image/svg+xml, image/webp"
                                />
                                <label
                                  htmlFor={`imageUpload${index}`}
                                  className="image-upload-cam d-flex justify-content-center align-items-center">
                                  <i className="ri-image-fill"></i>
                                </label>
                              </div>
                              <div className="avatar-preview">
                                <img
                                  className="preview-select-img img-responsive img-circle"
                                  id="imagePreview"
                                  alt="User profile picture"
                                  src={
                                    imageDisplay?.[index] ??
                                    categoryImagePlaceholder
                                  }
                                  style={{height: '110px'}}
                                />
                              </div>
                            </div>
                            {formik.touched.clubs?.[index]?.image &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {(formik.errors.clubs[index] as any)?.image}
                                </p>
                              )}
                          </div>
                        </td>

                        <td>
                          <div className="club-select">
                            <Form.Control
                              type="text"
                              name={`clubs[${index}].name`}
                              id={`name${index}`}
                              value={club.name}
                              onChange={formik?.handleChange}
                              // onBlur={formik?.handleBlur}
                              onBlur={async e => {
                                const isAvailable =
                                  await checkRestaurantNameAvailability(
                                    club?.name,
                                    index,
                                  );
                                formik?.handleBlur(e);
                              }}
                              isInvalid={
                                !!(
                                  formik.touched.clubs?.[index]?.name &&
                                  (formik.errors.clubs?.[index] as any)?.name
                                )
                              }
                            />
                            {formik.touched.clubs?.[index]?.name &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {(formik.errors.clubs[index] as any)?.name}
                                </p>
                              )}
                          </div>
                        </td>

                        <td>
                          <div className="mb-3 club-select">
                            <div className="d-flex"></div>
                            <Form.Select
                              className="form-select"
                              id={`is-active${index}`}
                              name={`clubs[${index}].is_active`}
                              value={club.is_active}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}>
                              <option value="">--Select Type--</option>
                              {clubType?.map((data: CategoryStatusList, i) => (
                                <option key={i} value={data.id}>
                                  {data.name}
                                </option>
                              ))}
                            </Form.Select>
                            {formik.touched.clubs?.[index]?.is_active &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {
                                    (formik.errors.clubs[index] as any)
                                      ?.is_active
                                  }
                                </p>
                              )}
                          </div>
                        </td>
                        <td>
                          <div className="mb-3 club-select">
                            <Form.Select
                              className="form-select"
                              name={`clubs[${index}].commision_status`}
                              id={`commision_status${index}`}
                              value={club.commision_status}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}
                              disabled={
                                formik.values.clubs?.[index]?.is_active === '3'
                              }>
                              <option value="">Select</option>
                              {status?.map((data: CategoryStatusList, i) => (
                                <option key={i} value={data.id}>
                                  {data.name}
                                </option>
                              ))}
                            </Form.Select>
                            {formik.touched.clubs?.[index]?.commision_status &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {
                                    (formik.errors.clubs[index] as any)
                                      ?.commision_status
                                  }
                                </p>
                              )}
                          </div>
                        </td>
                        <td>
                          <div className="mb-3 club-select">
                            <Form.Control
                              type="text"
                              name={`clubs[${index}].tag`}
                              id={`tag${index}`}
                              value={club.tag}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}
                              disabled={
                                formik.values.clubs?.[index]?.is_active === '3'
                              }
                              isInvalid={
                                !!(
                                  formik.touched.clubs?.[index]?.tag &&
                                  (formik.errors.clubs?.[index] as any)?.tag
                                )
                              }
                            />
                            {formik.touched.clubs?.[index]?.tag &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {(formik.errors.clubs[index] as any)?.tag}
                                </p>
                              )}
                          </div>
                        </td>
                        <td>
                          <div className="club-select">
                            <Form.Select
                              className="form-select "
                              name={`clubs[${index}].indoors`}
                              id={`indoors${index}`}
                              value={club.indoors}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}
                              disabled={
                                formik.values.clubs?.[index]?.is_active === '3'
                              }>
                              <option disabled value="">
                                --Select Indoors--
                              </option>
                              {status?.map((data: CategoryStatusList, i) => (
                                <option key={i} value={data.id}>
                                  {data.name}
                                </option>
                              ))}
                            </Form.Select>
                            {formik.touched.clubs?.[index]?.indoors &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {(formik.errors.clubs[index] as any)?.indoors}
                                </p>
                              )}
                          </div>
                        </td>
                        <td>
                          <div className="club-select">
                            <Form.Select
                              className="form-select "
                              name={`clubs[${index}].outdoors`}
                              id={`outdoors${index}`}
                              value={club.outdoors}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}
                              disabled={
                                formik.values.clubs?.[index]?.is_active === '3'
                              }>
                              <option disabled value="">
                                --Select Outdoors--
                              </option>
                              {status?.map((data: CategoryStatusList, i) => (
                                <option key={i} value={data.id}>
                                  {data.name}
                                </option>
                              ))}
                            </Form.Select>
                            {formik.touched.clubs?.[index]?.outdoors &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {
                                    (formik.errors.clubs[index] as any)
                                      ?.outdoors
                                  }
                                </p>
                              )}
                          </div>
                        </td>
                        <td>
                          <div className="club-select">
                            <Form.Select
                              className="form-select "
                              name={`clubs[${index}].bar`}
                              id={`bar${index}`}
                              value={club.bar}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}
                              disabled={
                                formik.values.clubs?.[index]?.is_active === '3'
                              }>
                              <option disabled value="">
                                --Select Bar--
                              </option>
                              {status?.map((data: CategoryStatusList, i) => (
                                <option key={i} value={data.id}>
                                  {data.name}
                                </option>
                              ))}
                            </Form.Select>
                            {formik.touched.clubs?.[index]?.bar &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {(formik.errors.clubs[index] as any)?.bar}
                                </p>
                              )}
                          </div>
                        </td>

                        <td>
                          <div className="club-select">
                            <Form.Select
                              className="form-select "
                              name={`clubs[${index}].guest_status`}
                              id={`guest_status${index}`}
                              value={club.guest_status}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}
                              disabled={
                                formik.values.clubs?.[index]?.is_active === '3'
                              }>
                              <option disabled value="">
                                --Select Guest List Status--
                              </option>
                              {guestStatus?.map(
                                (data: CategoryStatusList, i) => (
                                  <option key={i} value={data.id}>
                                    {data.name}
                                  </option>
                                ),
                              )}
                            </Form.Select>
                            {formik.touched.clubs?.[index]?.guest_status &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {
                                    (formik.errors.clubs[index] as any)
                                      ?.guest_status
                                  }
                                </p>
                              )}
                          </div>
                        </td>

                        <td>
                          <div className="club-select">
                            <Form.Control
                              type="time"
                              placeholder="Enter Venue opening Time"
                              name={`clubs[${index}].venue_open_time`}
                              id={`venue-open-time${index}`}
                              value={club.venue_open_time}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}
                              isInvalid={
                                !!(
                                  formik.touched.clubs?.[index]
                                    ?.venue_open_time &&
                                  (formik.errors.clubs?.[index] as any)
                                    ?.venue_open_time
                                )
                              }
                              disabled={
                                formik.values.clubs?.[index]?.is_active === '3'
                              }
                            />
                            {formik.touched.clubs?.[index]?.venue_open_time &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {
                                    (formik.errors.clubs[index] as any)
                                      ?.venue_open_time
                                  }
                                </p>
                              )}
                          </div>
                        </td>

                        <td>
                          <div className="club-select">
                            <Form.Control
                              type="time"
                              placeholder="Enter venue closing Time"
                              name={`clubs[${index}].venue_close_time`}
                              id={`venue-close-time${index}`}
                              value={club.venue_close_time}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}
                              isInvalid={
                                !!(
                                  formik.touched.clubs?.[index]
                                    ?.venue_close_time &&
                                  (formik.errors.clubs?.[index] as any)
                                    ?.venue_close_time
                                )
                              }
                              disabled={
                                formik.values.clubs?.[index]?.is_active === '3'
                              }
                            />
                            {formik.touched.clubs?.[index]?.venue_close_time &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {
                                    (formik.errors.clubs[index] as any)
                                      ?.venue_close_time
                                  }
                                </p>
                              )}
                          </div>
                        </td>

                        {/* {formik.values.clubs?.[index]?.guest_status &&
                        formik.values.clubs?.[index]?.guest_status == '1' ? (
                          <> */}
                        <td>
                          <div className="club-select">
                            <Form.Control
                              type="time"
                              placeholder="Enter guestlist opening Time"
                              name={`clubs[${index}].guestlist_open_time`}
                              id={`guestlist-open-time${index}`}
                              value={club.guestlist_open_time}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}
                              isInvalid={
                                !!(
                                  formik.touched.clubs?.[index]
                                    ?.guestlist_open_time &&
                                  (formik.errors.clubs?.[index] as any)
                                    ?.guestlist_open_time
                                )
                              }
                              disabled={
                                formik.values.clubs?.[index]?.is_active ===
                                  '3' ||
                                formik.values.clubs?.[index]?.guest_status !=
                                  '1'
                              }
                            />
                            {formik.touched.clubs?.[index]
                              ?.guestlist_open_time &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {
                                    (formik.errors.clubs[index] as any)
                                      ?.guestlist_open_time
                                  }
                                </p>
                              )}
                          </div>
                        </td>

                        <td>
                          <div className="club-select">
                            <Form.Control
                              type="time"
                              placeholder="Enter guestlist closing Time"
                              name={`clubs[${index}].guestlist_close_time`}
                              id={`guestlist-close-time${index}`}
                              value={club.guestlist_close_time}
                              onChange={formik?.handleChange}
                              onBlur={formik?.handleBlur}
                              isInvalid={
                                !!(
                                  formik.touched.clubs?.[index]
                                    ?.guestlist_close_time &&
                                  (formik.errors.clubs?.[index] as any)
                                    ?.guestlist_close_time
                                )
                              }
                              disabled={
                                formik.values.clubs?.[index]?.is_active ===
                                  '3' ||
                                formik.values.clubs?.[index]?.guest_status !=
                                  '1'
                              }
                            />
                            {formik.touched.clubs?.[index]
                              ?.guestlist_close_time &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {
                                    (formik.errors.clubs[index] as any)
                                      ?.guestlist_close_time
                                  }
                                </p>
                              )}
                          </div>
                        </td>
                        {/* </>
                        ) : (
                          <>
                            <td></td>
                            <td></td>
                          </>
                        )
                      } */}

                        <td>
                          <div className="mb-3 club-select">
                            <div className="d-flex"></div>
                            <Form.Select
                              className="form-select"
                              id={`status-Field${index}`}
                              name={`clubs[${index}].status`}
                              value={club.status}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}>
                              <option disabled value="">
                                --Select Status--
                              </option>
                              {statusType?.map(
                                (data: CategoryStatusList, i) => (
                                  <option key={i} value={data.id}>
                                    {data.name}
                                  </option>
                                ),
                              )}
                            </Form.Select>
                            {formik.touched.clubs?.[index]?.status &&
                              formik.errors.clubs?.[index] && (
                                <p className="text-danger">
                                  {(formik.errors.clubs[index] as any)?.status}
                                </p>
                              )}
                          </div>
                        </td>

                        {/* <td>
                            <Button
                              variant="primary"
                              type="button"
                              onClick={() => {
                                formik?.handleSubmit();
                              }}
                              disabled={isDisabled} // Disable button after submit
                            >
                              Submit
                            </Button>
                          </td> */}

                        <td className="text-center align-middle">
                          <div className="d-flex  align-items-center justify-content-center">
                            {index === formik.values.clubs.length - 1 && (
                              <Button
                                variant="success"
                                type="button"
                                className="d-flex align-items-center justify-content-center me-1"
                                style={{
                                  width: '32px',
                                  height: '32px',
                                  fontSize: '20px',
                                  padding: '0',
                                }}
                                onClick={addRow}>
                                +
                              </Button>
                            )}

                            {/* "-" Button: Shows on all rows except the first */}
                            {formik.values.clubs.length > 1 && (
                              <Button
                                variant="danger"
                                type="button"
                                className=" d-flex align-items-center justify-content-center mt-1 me-1"
                                style={{
                                  width: '32px',
                                  height: '32px',
                                  fontSize: '20px',
                                  padding: '0',
                                }}
                                onClick={async () => {
                                  await removeRow(index);
                                }}>
                                -
                              </Button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </>
                )}
              </tbody>
            </Table>
            <div className=" m-2">
              {!editData?.id ? (
                <Button
                  variant="primary"
                  onClick={async () => await formik.submitForm()}
                  className="mt-3">
                  Add Club
                </Button>
              ) : (
                <Button
                  variant="primary"
                  type="button"
                  onClick={handleEditSubmit}>
                  Edit Club
                </Button>
              )}
            </div>
          </div>
        </Col>
      </Row>
      {/* </Container> */}
    </div>
  );
};

export default ClubForm;
